import { nomeArquivoSalvo, legendaMidia } from "./legendaMidia";

// Nome ORIGINAL do documento — só existe no payload cru (Message.json), porque
// o arquivo é salvo com nome de servidor. Oficial só grava o `filename` desde o #15017.
export const nomeOriginalDocumento = (message) => {
  if (!message?.json) return null;
  try {
    const payload = typeof message.json === "string" ? JSON.parse(message.json) : message.json;
    const documento = payload?.message?.documentMessage
      || payload?.message?.documentWithCaptionMessage?.message?.documentMessage;
    return documento?.fileName || payload?.message?.oficialMediaMessage?.filename || null;
  } catch (err) {
    return null;
  }
};

// Arquivos gravados antes do #15017: extensão errada no disco, bytes certos.
const EXTENSAO_ANTIGA = {
  sheet: "xlsx",
  document: "docx",
  presentation: "pptx",
  msword: "doc",
  "ms-excel": "xls",
  "ms-powerpoint": "ppt",
  text: "odt",
  spreadsheet: "ods",
  plain: "txt",
};

const extensao = (nome) => {
  const m = /\.([a-z0-9-]{1,15})$/i.exec(nome || "");
  return m ? m[1].toLowerCase() : "";
};

const extensaoCorrigida = (nomeSalvo) => {
  const ext = extensao(nomeSalvo);
  return EXTENSAO_ANTIGA[ext] || ext;
};

// Só o anexo tem card de download (o último `else` do checkMessageMedia). Texto não tem
// arquivo, e "185.65.15" ou "Creta 1.6" passam no pareceNomeDeArquivo.
const MIDIA_SEM_CARD = ["image", "audio", "video", "vcard", "location"];
const temCardDeAnexo = (message) =>
  !!message?.mediaUrl && !MIDIA_SEM_CARD.includes(message.mediaType);

// Oficial sem legenda grava o nome original no body — é o que sobra na mensagem antiga.
const pareceNomeDeArquivo = (texto) =>
  !!texto && texto.length <= 255 && !/[\r\n/\\]/.test(texto) && /\.[a-z0-9]{1,10}$/i.test(texto);

// Nome que a pessoa reconhece — o que ela deu ao arquivo. `null` quando só temos o nome
// gerado pelo servidor (1769606400000-ab12cd.pdf), que não é nome de nada.
export const nomeRealDoArquivo = (message) => {
  const nome = nomeOriginalDocumento(message);
  if (nome) return nome;
  if (!temCardDeAnexo(message)) return null;

  const salvo = nomeArquivoSalvo(message) || "arquivo";
  const corpo = (message?.body || "").trim();
  if (corpo !== salvo && pareceNomeDeArquivo(corpo)) return corpo;

  return null;
};

// Nome com que o botão Download salva o arquivo: o que aparece no balão (#15017). Nome
// original sem extensão é completado com a do arquivo salvo, senão não abre.
export const nomeDownloadMidia = (message) => {
  const salvo = nomeArquivoSalvo(message) || "arquivo";
  const extSalvo = extensaoCorrigida(salvo);

  const nome = nomeRealDoArquivo(message);
  if (nome) {
    return extensao(nome) || !extSalvo ? nome : `${nome}.${extSalvo}`;
  }

  const base = salvo.replace(/\.[^.]*$/, "");
  return extSalvo ? `${base}.${extSalvo}` : base;
};

// Nome exibido no card de download (#15203). É o MESMO texto com que o botão salva o
// arquivo — balão e download dizendo nomes diferentes seria pior que não dizer nada.
// `null` quando não há nome real: aí o card continua como sempre foi, só com o botão.
export const nomeArquivoNoCard = (message) =>
  temCardDeAnexo(message) && nomeRealDoArquivo(message) ? nomeDownloadMidia(message) : null;

// Legenda embaixo do card que já mostra o nome. Documento oficial sem legenda guarda o
// nome original no body, e ele sairia repetido.
export const legendaAbaixoDoCard = (message) => {
  const legenda = legendaMidia(message);
  return legenda.trim() === nomeRealDoArquivo(message) ? "" : legenda;
};
